import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import AddOnRow from './row/';
import Button from '../../button';
import WhitePlusSign from '../../../assets/add-ons/white_plus.svg';
import LoadingSpinner from '../../loading';
import { locale } from './locale';
import styles from './mobile-styles-module.css';
import { CREATE_ADDON_URL, SHOW_ALL } from '../consts';

const MobileAddOnsTable = injectIntl((props) => {
  const {
    intl,
    loading,
    hasPermissionForManageAddOns,
    renderNoAddOnFound,
    selectedStatus,
    history,
    renderAddOnStatusFilter,
    renderAddOnsSearch,
    addOnSearch,
    searchEventKey,
    renderAddonsFilterByEvent,
    setSearchedEventList,
    listings,
    handleOnAddOnsDelete,
    handleOnAddOnsStatusChange,
  } = props;
  let content;

  useEffect(() => {
    setSearchedEventList(listings);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listings])

  const isFilterApplied = addOnSearch?.length > 0 || searchEventKey?.length > 0 || selectedStatus !== SHOW_ALL;

  const drawTable = () => {
    const addOns = Object.assign([], props.addOns);
    if (addOns.length) {
      return addOns.map((addOn, index) => {
        return <AddOnRow
          key={addOn.id}
          addOn={addOn}
          handleOnAddOnsStatusChange={handleOnAddOnsStatusChange}
          handleOnAddOnsDelete={handleOnAddOnsDelete}
          index={index}
          intl={intl}
          rate={addOn.rates}
          hasPermissionForManageAddOns={hasPermissionForManageAddOns}
          history={history}
        />;
      });
    }

    return renderNoAddOnFound(isFilterApplied);
  }
  
  if (loading) {
    content = (
      <div className={styles.row}>
        <LoadingSpinner className={styles.loadingSpinner} />
      </div>
    );
  }
  else {
    content = drawTable();
  }

  const displayCreateButton = () => {
    return (
      <Link to={CREATE_ADDON_URL}>
        <Button className={`blue ${styles.createAddOnBtn}`}>
          <WhitePlusSign />
          {intl.formatMessage(locale.createAddOn)}
        </Button>
      </Link>
    );
  }

  return  (
    <div className={styles.mobileAddOnsTable}>
      <div className={styles.filterAndCreateRow}>
        {renderAddOnStatusFilter()}
        {renderAddOnsSearch()}
        {renderAddonsFilterByEvent()}
        {hasPermissionForManageAddOns && displayCreateButton()}
      </div>
      {content}
    </div>
  );
});

export default MobileAddOnsTable;
